import React, { useEffect, useState } from 'react';
import SharedButton from '../../components/Shared/SharedButton';
import { useTranslation } from 'react-i18next';
import AllowanceTable from './AllowanceTable';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../../hooks/useFetchData';

export default function AllowanceMain() {
  const { data: allowanceData, loading, executeFetch } = useFetchData();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    executeFetch("POST", "allowances/list", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "allowances/list", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "allowances/list", { page: 1, per_page: 10 });
  };

  return (
    <>
      <div>
        <div className='flex justify-end mb-2 '>
          <SharedButton
            label={t('CreateAllowance')}
            icon='pi pi-plus'
            onClick={() => navigate('/manager/allowance/create')}
            className='bg-primary primary-btn'
          />
        </div>
        <AllowanceTable
          data={allowanceData}
          loading={loading}
          onPageChange={handlePageChange}
          onRefresh={handleRefresh}
        />
      </div>
    </>
  );
}
